import 'isomorphic-fetch';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/array';
import 'core-js/es6/string';
import 'core-js/es6/number';
import 'core-js/es6/date';
import 'core-js/es6/promise';
import 'core-js/es6/symbol';
import 'core-js/es7/string';
import 'core-js/es7/array';
import 'core-js/modules/es7.object.values';
import 'core-js/modules/es7.object.entries';
import 'regenerator-runtime/runtime';
